export default __webpack_public_path__ + "static/media/1797.82a5e8b7.png";